import React, { FC } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import Subtitle from 'src/components/ui/Subtitle'
import Button from 'src/components/ui/Button'
import styled from 'styled-components'

interface IWebinarProps {
  className?: string
  webinarPresentationLink: string
  videoEmbedId: string
}

export const StyledIframe = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 1.5rem;
  overflow: hidden;
`

const Webinar: FC<IWebinarProps> = ({
  className,
  videoEmbedId,
  webinarPresentationLink,
}) => {
  const { t } = useTranslation('webinar-section')

  return (
    <section
      id="webinar"
      className={`${className} container py-10 md:py-20 bg-transparent`}
      data-name={t('watch out webinar')}
    >
      <Subtitle className="mb-8 md:mb-12 text-left">
        {t('Watch our webinar')}
      </Subtitle>

      <div className="mb-12 text-center">
        <StyledIframe
          className="mx-auto max-w-full"
          src={`https://www.youtube.com/embed/${videoEmbedId}`}
          title="Webinar video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="text-center">
        <a href={webinarPresentationLink} rel="noreferrer" target="_blank" className="flex w-full md:inline-flex md:w-auto justify-center">
          <Button type="submit" className="w-full md:w-auto">{t('download the presentation')}</Button>
        </a>
      </div>
    </section>
  )
}
Webinar.defaultProps = {
  className: '',
}

export default Webinar
